import { I18N_NAMESPACE } from "../../../common/constants/i18n"

export const VERTICAL_SIGNING_CONDITION_GOOD = 10
export const VERTICAL_SIGNING_CONDITION_MEDIUM = 20
export const VERTICAL_SIGNING_CONDITION_BAD = 30
export const VERTICAL_SIGNING_CONDITION_UNKNOWN = -1
export const VERTICAL_SIGNING_CONDITIONS = [
    VERTICAL_SIGNING_CONDITION_GOOD,
    VERTICAL_SIGNING_CONDITION_MEDIUM,
    VERTICAL_SIGNING_CONDITION_BAD,
    VERTICAL_SIGNING_CONDITION_UNKNOWN,
]

export const getVerticalSigningConditionsValues = (t, theme) => ({
    [VERTICAL_SIGNING_CONDITION_BAD]: {
        backgroundColor: theme.palette["red/100"]?.main,
        labelColor: theme.palette["error"]?.main,
        color: theme.palette["error"]?.main,
        label: t(I18N_NAMESPACE, "components.verticalSignsConditionCount.bad"),
        legendLabel: t(I18N_NAMESPACE, "containers.verticalSign.legend.conditions.texts.bad"),
    },
    [VERTICAL_SIGNING_CONDITION_MEDIUM]: {
        backgroundColor: theme.palette["orange/100"]?.main,
        labelColor: theme.palette["_components/legend/DPE/orange-foncé"]?.main,
        color: theme.palette["_components/legend/DPE/orange"]?.main,
        label: t(I18N_NAMESPACE, "components.verticalSignsConditionCount.medium"),
        legendLabel: t(I18N_NAMESPACE, "containers.verticalSign.legend.conditions.texts.medium"),
    },
    [VERTICAL_SIGNING_CONDITION_GOOD]: {
        backgroundColor: theme.palette["brand logiroad/primary/100"]?.main,
        labelColor: theme.palette["primary"]?.main,
        color: theme.palette["primary"]?.main,
        label: t(I18N_NAMESPACE, "components.verticalSignsConditionCount.good"),
        legendLabel: t(I18N_NAMESPACE, "containers.verticalSign.legend.conditions.texts.good"),
    },
    [VERTICAL_SIGNING_CONDITION_UNKNOWN]: {
        backgroundColor: theme.palette["common/gray_states"]?.main,
        labelColor: theme.palette["common/gray_states"]?.main,
        color: theme.palette["common/gray_states"]?.dark,
        label: "",
        legendLabel: t(I18N_NAMESPACE, "containers.verticalSign.legend.conditions.texts.unknown"),
    },
})

export const getVerticalSigningLegendConfig = (t, theme) => {
    return Object.values(getVerticalSigningConditionsValues(t, theme)).map(conditionValue => {
        return {
            color: conditionValue.color,
            label: conditionValue.legendLabel,
        }
    })
}

